export enum Classes {
    facetGroup = 'facet-group',
}
